/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Drag_Close_Not_AllowedInputs */

const vi_work_activity_drag_close_not_allowed = /** @type {(inputs: Work_Activity_Drag_Close_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ người giao việc mới được đóng hoặc bắt làm lại nhiệm vụ này.`)
};

/**

* @param {Work_Activity_Drag_Close_Not_AllowedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_drag_close_not_allowed = /** @type {((inputs?: Work_Activity_Drag_Close_Not_AllowedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Drag_Close_Not_AllowedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_drag_close_not_allowed(inputs)
});